import { render } from "./ConfigurationForm.vue?vue&type=template&id=18d4c30c"
import script from "./ConfigurationForm.vue?vue&type=script&lang=js"
export * from "./ConfigurationForm.vue?vue&type=script&lang=js"
script.render = render

export default script